import { createAction } from "@reduxjs/toolkit";

export const adRewardStatusRequest = createAction("adReward/status/request");
export const adRewardStatusSuccess = createAction<{
  hasPendingReward: boolean;
  chips: number;
  state: "created" | "approved" | null;
  cooldownMinutesLeft: number;
  adsWatchedThisHour: number;
  adsRemainingThisHour: number;
}>("adReward/status/success");
export const adRewardStatusFailure = createAction<string>(
  "adReward/status/failure",
);

export const adRewardClaimRequest = createAction("adReward/claim/request");
export const adRewardClaimSuccess = createAction<{ chips: number }>(
  "adReward/claim/success",
);
export const adRewardClaimFailure = createAction<string>(
  "adReward/claim/failure",
);

/** Fired after the IronSource ad completes — kicks off polling */
export const adRewardStartPolling = createAction("adReward/polling/start");
export const adRewardStopPolling = createAction("adReward/polling/stop");

